'use strict';

import { ConfigurationRequest } from './ConfigurationRequest';
import { DomainContext } from '../../../../parametrage/DomainContext';

class GridViewRequest extends ConfigurationRequest {
    constructor(domain: DomainContext, _id? : string){
        super('grid', domain, _id);
    }
}

export { GridViewRequest };